import React, { useEffect, useRef, useState } from 'react';

import { appendBSlatSegments } from './aboutUsSlatBMarkBuild';

const MORPH_MS = 2600;
const HOLD_REVEALED_MS = 2200;
const HOLD_SOLID_MS = 2400;

/**
 * About hero: slat lens morphs between solid circle and letter B on a loop (same idea as circle-b-loading-loop.html).
 */
const AboutUsSlatMark = ({ label }) => {
  const rootRef = useRef(null);
  const layerRef = useRef(null);
  const [segmentsReady, setSegmentsReady] = useState(false);

  useEffect(() => {
    const g = layerRef.current;
    if (!g) return undefined;
    appendBSlatSegments(g);
    setSegmentsReady(true);
    return () => {
      while (g.firstChild) {
        g.removeChild(g.firstChild);
      }
      setSegmentsReady(false);
    };
  }, []);

  useEffect(() => {
    if (!segmentsReady) return undefined;
    const root = rootRef.current;
    if (!root) return undefined;

    if (typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    const timeouts = [];

    function openPhase() {
      root.classList.add('about-us-slat-mark--revealed');
      timeouts.push(window.setTimeout(closePhase, MORPH_MS + HOLD_REVEALED_MS));
    }

    function closePhase() {
      root.classList.remove('about-us-slat-mark--revealed');
      timeouts.push(window.setTimeout(openPhase, MORPH_MS + HOLD_SOLID_MS));
    }

    timeouts.push(window.setTimeout(openPhase, HOLD_SOLID_MS));

    return () => {
      timeouts.forEach((id) => window.clearTimeout(id));
      root.classList.remove('about-us-slat-mark--revealed');
    };
  }, [segmentsReady]);

  return (
    <div ref={rootRef} className="about-us-slat-mark" role="img" aria-label={label}>
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <filter
            id="about-us-slat-b-shade"
            x="-25%"
            y="-25%"
            width="150%"
            height="150%"
            colorInterpolationFilters="sRGB"
          >
            <feDropShadow
              dx="0"
              dy="1"
              stdDeviation="0.9"
              floodColor="#0f172a"
              floodOpacity="0.11"
            />
          </filter>
        </defs>
        <g ref={layerRef} className="about-us-slat-layer" filter="url(#about-us-slat-b-shade)" />
      </svg>
    </div>
  );
};

export default AboutUsSlatMark;
